import { css } from 'lit';

var css_248z = css`:host{--alert-icon-margin-right:0.5rem}slot[name=icon]::slotted(svg){margin-right:var(--alert-icon-margin-right);vertical-align:unset!important}i{position:relative;top:2px}`;

export { css_248z as default };
//# sourceMappingURL=sgds-alert2.js.map
